
import Heading from "../../../components/heading/heading.component";
import { TermsAndConditionsContainer } from "./TermsAndConditions.styles";
import { termsAndConditionsText } from "./termsAndConditionsText"

export const TermsAndConditions = ({ isPopup }) => {

  const formattedText = termsAndConditionsText.split('\n').map((line, index) => {
    const titleMatch = line.match(/^(\d+(\.\d+)*\.)/);
    
    if (titleMatch) {
      return (
        <p key={index}>
          <strong>{titleMatch[0]}</strong> {line.slice(titleMatch[0].length)}
        </p>
      );
    }
    return <p key={index}>{line}</p>;
  });

  return (
    <>
    {
    isPopup 
    ?
    <div style={{maxHeight: "250px", overflow: "auto"}}>
      <div>{formattedText}</div>
      <FooterContactUs/>
    </div>
    : 
    <TermsAndConditionsContainer className="App login_page">
      <Heading previusPage={'Terms And Conditions'} />
      <div>{formattedText}</div>
      <FooterContactUs/>
    </TermsAndConditionsContainer>
    }
    </>
  );
}

const FooterContactUs = () => {
  return(
    <div>
          <strong>Contact Us</strong>
          <p>If you have any questions or concerns about these terms and conditions, please contact us at:</p>
          <h3>MusicBull</h3> 
          <p>MusicBull Is a Multipiece Exchange Ltd. Company <br/>
              Our address:<br/>
              6104 Highland Hills Dr. Austin, TX, 78731<br/>
              <strong>Phone Number:</strong><br/>
              +1646-389-1646<br/>
              <strong>Email</strong><br/>
              Contact@MusicBull.com
          </p>
        </div>
  )
}

export default TermsAndConditions;